//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sliderItem from '@/components/slider/slider.vue'
import sliderMarks from '@/components/slider/sliderMarks'
export default {
  props: {
    desc: {
      type: String,
      default: '',
    },
    question: {
      type: Object,
      default: {},
    },
    src: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    blankVisible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  components: {
    sliderItem,
    sliderMarks,
  },
  data() {
    return {}
  },
  methods: {},
}
